import type { track as TrackFunction } from "pro-features/components/WithTrack/src/WithTrack";
import createTrackingEventName from "app/pages/sales-intelligence/utils/testing/createTrackingEventName";
import { allTrackers } from "app/services/track/track";

const createColumnsSuggestionsTrackingService = (trackEvent: TrackFunction) => {
    const trackWithCategory = (action: string, eventName: string): void => {
        trackEvent("column suggestions", action, eventName);
    };

    return {
        trackApplyClicked(numberOfAllSuggestions: number, numberOfSelectedSuggestions: number) {
            const eventName = createTrackingEventName(
                "add column suggestions",
                numberOfAllSuggestions,
                numberOfSelectedSuggestions,
            );

            trackWithCategory("click", eventName);
        },
        trackCancelClicked(numberOfAllSuggestions: number) {
            const eventName = createTrackingEventName("view all columns", numberOfAllSuggestions);

            trackWithCategory("click", eventName);
        },
        trackTooltipHovered(numberOfAllSuggestions: number) {
            const eventName = createTrackingEventName("column suggestions tooltip", numberOfAllSuggestions);

            trackWithCategory("hover", eventName);
        },
    };
};

export const columnsSuggestionsTrackingService = createColumnsSuggestionsTrackingService(
    allTrackers.dispatchTrackEvent.bind(allTrackers),
);
